module.exports = __webpack_public_path__ + "static/logo-chitf-australia-3ccebd099f34c94bf0835933ffbf5056.png";